import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useState, useMemo, useEffect } from "react"
import { FaCircleCheck, FaPen, FaPlus } from "react-icons/fa6"
import { MdAdd, MdDelete, MdEmail, MdMenu, MdSettings } from "react-icons/md"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
} from "reactstrap"
import LocationModal from "./LocationModal"
import Swal from "sweetalert2"
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaClock,
  FaEye,
  FaFileContract,
  FaFilePdf,
  FaSearch,
  FaSync,
} from "react-icons/fa"
import LocationTimeModal from "./LocationTime"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import moment from "moment"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import ContractModal from "./ContractModal"
import ContractPDF from "./ContractPDF"

const LocationIndex = () => {
  const [contractModal, setContractModal] = useState(false)

  const [loading, setLoading] = useState(false)

  const [modalType, setModalType] = useState("")
  const [selectedLocation, setselectedLocation] = useState({})

  const [services, setservices] = useState([])
  const [employees, setemployees] = useState([])

  const [perPageItem, setPerPageItem] = useState(10)
  const [searchString, setSearchString] = useState("")
  const [currentPage, setCurrentPage] = useState(1)

  const [locationTypeFilter, setLocationTypeFilter] = useState("")

  const [timeToggle, setTimeToggle] = useState(false)

  const [locationList, setLocationList] = useState([])

  const [holiday, setHoliday] = useState({
    date: "",
    reason: "",
  })

  const [sageOptions, setSageOptions] = useState([])

  useEffect(() => {
    fetchlocations()
    fetchEmpServiceData()
    fetchSageOptions()
  }, [])

  async function fetchlocations() {
    const APIData = await fetchData(setLoading, "location")

    if (APIData?.data) {
      const parsedData = APIData.data.map(item => ({
        ...item,
        type: item?.type ? JSON.parse(item.type) : [],
      }))

      const reversed = parsedData.reverse()
      setLocationList(reversed)

      if (selectedLocation?.id) {
        const updated = reversed.find(loc => loc.id === selectedLocation.id)
        if (updated) setselectedLocation(updated)
      }
    }
  }

  async function fetchSageOptions() {
    const APIData = await fetchData(setLoading, "location/sage/contacts")

    if (APIData?.success) {
      setSageOptions(APIData?.data?.reverse())
    }
  }

  async function fetchEmpServiceData() {
    const APIdata = await fetchData(setLoading, "employee")
    if (APIdata?.data) {
      setemployees(APIdata?.data)
    }

    const APIdata2 = await fetchData(setLoading, "services")
    if (APIdata2?.data) {
      setservices(APIdata2?.data)
    }
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [locationData, setLocationData] = useState({})
  const [holidayModal, setHolidayModal] = useState(false)

  const [offmodal, setOffModal] = useState(false)

  const toggleModal = () => setIsModalOpen(!isModalOpen)

  const handleChange = e => {
    const { name, value } = e.target
    setLocationData(prev => ({ ...prev, [name]: value }))
  }

  const handleSave = async () => {
    if (locationData.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "location",
        locationData.id,
        locationData
      )
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Success",
          text: "Location Updated Successfully",
          icon: "success",
        })
        fetchlocations()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    } else {
      const APIdata = await FetchPostData(setLoading, "location", locationData)
      if (APIdata?.data?.success) {
        Swal.fire({
          title: "Success",
          text: "Location Added Successfully",
          icon: "success",
        })
        fetchlocations()
      } else {
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.response?.data?.message,
          icon: "error",
        })
      }
    }
    toggleModal()
  }

  // 🔍 Filter + Paginate location
  const filteredLocation = useMemo(() => {
    const search = searchString.toLowerCase()

    return locationList.filter(loc => {
      const matchesSearch =
        loc.name.toLowerCase().includes(search) ||
        loc.address.toLowerCase().includes(search)

      const matchesType =
        !locationTypeFilter?.length ||
        loc.type?.some(t => locationTypeFilter.includes(t))

      return matchesSearch && matchesType
    })
  }, [locationList, searchString, locationTypeFilter])

  const totalPages = Math.ceil(filteredLocation.length / perPageItem)

  const paginatedLocation = useMemo(() => {
    const start = (currentPage - 1) * perPageItem
    return filteredLocation.slice(start, start + perPageItem)
  }, [filteredLocation, currentPage, perPageItem])

  const handleDelete = async (id, name) => {
    const result = await Swal.fire({
      title: "Are You Sure?",
      text: `You want to delete ${name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3d6eb6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it",
    })

    if (result.isConfirmed) {
      try {
        const APIdata = await FetchDeleteData(setLoading, "location", id)

        if (APIdata?.data) {
          await Swal.fire({
            title: "Location Deleted Successfully.",
            icon: "success",
          })
          fetchlocations()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIdata?.response?.data?.message || "Please try again later.",
            icon: "error",
          })
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err?.message || "Failed to delete location.",
          icon: "error",
        })
      }
    }
  }

  const toggleStatus = async (id, newStatus) => {
    // Ask for confirmation first
    const result = await Swal.fire({
      title: "Are You Sure?",
      text: `You want to change status of this Location to ${
        newStatus ? "Active" : "Inactive"
      }?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonColor: "#3d6eb6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    })

    if (!result.isConfirmed) {
      // Revert switch visually if user cancels
      setLocationList(prev =>
        prev.map(loc => (loc.id === id ? { ...loc, status: !newStatus } : loc))
      )
      return
    }

    // Proceed if confirmed
    setLoading(true)
    try {
      const APIdata = await FetchPutData(setLoading, "location", id, {
        status: newStatus,
      })

      if (APIdata?.data?.success) {
        setLocationList(prev =>
          prev.map(loc => (loc.id === id ? { ...loc, status: newStatus } : loc))
        )
        await Swal.fire({
          title: "Status Updated Successfully.",
          icon: "success",
        })
      } else {
        // Revert on failure
        setLocationList(prev =>
          prev.map(loc =>
            loc.id === id ? { ...loc, status: !newStatus } : loc
          )
        )
        Swal.fire({
          title: "Something Went Wrong",
          text: APIdata?.response?.data?.message || "Please try again later.",
          icon: "error",
        })
      }
    } catch (err) {
      // Revert on exception
      setLocationList(prev =>
        prev.map(loc => (loc.id === id ? { ...loc, status: !newStatus } : loc))
      )
      Swal.fire({
        title: "Error",
        text: err?.message || "Failed to update location status.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  const { checkAccess } = usePermissionData()

  const AddHoliday = async () => {
    if (holiday?.date === "" || holiday?.reason === "") {
      Swal.fire({
        title: "Please Add All Details",
        text: "Date or Reason is not Added",
        icon: "warning",
      })
      return
    }

    const APIdata = await FetchPostData(setLoading, "public/holiday", {
      date: holiday?.date,
      locationId: selectedLocation?.id,
      reason: holiday?.reason,
    })

    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Holiday Added Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
      setHoliday({
        date: "",
        reason: "",
      })
      fetchlocations()
      setHolidayModal(false)
    } else {
      Swal.fire({
        title: "Something Went Wrong.",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  const DeleteHoliday = async id => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This holiday will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    })

    // ❌ User cancelled
    if (!result.isConfirmed) return

    const APIdata = await FetchDeleteData(setLoading, "public/holiday", id)

    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Holiday Deleted Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
      fetchlocations()
    } else {
      Swal.fire({
        title: "Something Went Wrong.",
        text: APIdata?.response?.data?.message || "Unable to delete holiday.",
        icon: "error",
      })
    }
  }

  const handleSync = async () => {
    const Apidata = await fetchData(setLoading, "sage/customers/only")
    if (Apidata?.success) {
      Swal.fire("Success", "Sage Contacts Synced Successfully.", "success")
      fetchSageOptions()
    }
  }

  const [pdfModal, setPDFModal] = useState(false)

  return (
    <div className="page-content">
      <PermittedComponent isAccess={checkAccess(5, 1) || checkAccess(5, 2)}>
        <Container fluid>
          <Breadcrumb
            title="Dashboard"
            breadcrumbItem="Location"
            description="Manage the all client locations from here"
          />
          {loading && <Loader />}
          <Row>
            <Col lg="12" className="px-0 h-100">
              <Card className="mb-0 shadow-lg">
                <CardBody>
                  {/* Header Controls */}
                  <div className="d-flex justify-content-between flex-wrap gap-2">
                    <div className="d-flex gap-3 flex-wrap">
                      <select
                        className="form-select rounded-4 ps-3 pe-5 w-auto"
                        value={perPageItem}
                        onChange={e => {
                          setPerPageItem(Number(e.target.value))
                          setCurrentPage(1)
                        }}
                      >
                        <option value={10}>Show 10</option>
                        <option value={20}>Show 20</option>
                        <option value={50}>Show 50</option>
                      </select>

                      <select
                        className="form-select rounded-4 ps-3 pe-5 w-auto"
                        value={locationTypeFilter}
                        onChange={e => {
                          setLocationTypeFilter(e.target.value)
                          setCurrentPage(1)
                        }}
                      >
                        <option value="">All (Both Type)</option>
                        <option value="window_cleaning">Window Cleaning</option>
                        <option value="industrial_cleaning">
                          Industrial Cleaning
                        </option>
                      </select>

                      <div className="position-relative">
                        <input
                          className="form-control rounded-4 px-3 pe-5"
                          placeholder="Search Location"
                          value={searchString}
                          onChange={e => setSearchString(e.target.value)}
                        />
                        <span className="position-absolute end-0 top-50 translate-middle-y pe-3 text-muted">
                          <FaSearch />
                        </span>
                      </div>
                    </div>

                    {checkAccess(5, 3) && (
                      <div className="d-flex gap-3">
                        {/* <Button className="btn-blue" onClick={handleSync}>
                          <FaSync className="me-2" /> Sync Sage Contacts
                        </Button> */}
                        <Button
                          className="btn-blue"
                          onClick={() => {
                            setLocationData({ employmentType: "contractual" })
                            toggleModal()
                            setModalType("add")
                          }}
                        >
                          <FaPlus className="me-2" /> Location
                        </Button>
                      </div>
                    )}
                  </div>

                  {/* Location Table */}
                  <div className="mt-5" style={{ overflowX: "auto" }}>
                    <Table responsive hover style={{ minWidth: "1100px" }}>
                      <thead className="bg-blue text-white">
                        <tr>
                          <th>#</th>
                          <th>Location Name</th>
                          <th>Address</th>
                          <th>Price</th>
                          {/* <th className="text-center">Services</th> */}
                          <th className="text-center">Employees</th>
                          <th className="text-center">Off Dates</th>
                          <th className="text-center">Holiday Dates</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Actions</th>
                          <th className="ps-5" style={{ minWidth: "16%" }}>
                            Contract
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedLocation.length > 0 ? (
                          paginatedLocation.map((loc, index) => (
                            <tr key={loc.id}>
                              <td>
                                {(currentPage - 1) * perPageItem + index + 1}
                              </td>
                              <td className="text-wrap-safe">{loc.name}</td>
                              <td className="text-wrap-safe">{loc.address}</td>
                              <td>£ {loc?.employeePrice}</td>
                              {/* <td className="text-center">
                                {loc?.services
                                  ? JSON?.parse(loc?.services).length
                                  : "0"}
                              </td> */}
                              <td className="text-center">
                                {loc?.employeeCount}
                              </td>
                              <td className="text-center">
                                {loc?.holidays.length}{" "}
                                <Button
                                  size="sm"
                                  className="btn-info ms-2 p-1"
                                  onClick={() => {
                                    setselectedLocation(loc)
                                    setHolidayModal(true)
                                  }}
                                >
                                  <FaCircleCheck size={14} />
                                </Button>
                              </td>
                              <td className="text-center">
                                {loc?.publicHolidays.length}{" "}
                                <Button
                                  size="sm"
                                  className="btn-info ms-2 p-1"
                                  onClick={() => {
                                    setselectedLocation(loc)
                                    setOffModal(true)
                                  }}
                                >
                                  <FaCircleCheck size={14} />
                                </Button>
                              </td>
                              <td>
                                <div className="form-check form-switch d-flex justify-content-center">
                                  <Input
                                    type="switch"
                                    checked={loc?.status}
                                    onChange={e =>
                                      toggleStatus(loc.id, e.target.checked)
                                    }
                                  />
                                </div>
                              </td>
                              <td className="">
                                <div className="d-flex justify-content-center flex-nowrap">
                                  {checkAccess(5, 4) && (
                                    <Button
                                      size="sm"
                                      className="btn-warning me-2"
                                      onClick={() => {
                                        setselectedLocation(loc)
                                        setTimeToggle(true)
                                      }}
                                    >
                                      <FaClock size={14} />
                                    </Button>
                                  )}
                                  <Button
                                    size="sm"
                                    className="me-2 btn-blue"
                                    onClick={() => {
                                      setLocationData(loc)
                                      toggleModal()
                                      setModalType("view")
                                    }}
                                  >
                                    <FaEye size={14} />
                                  </Button>
                                  {checkAccess(5, 4) && (
                                    <Button
                                      color="success"
                                      size="sm"
                                      className="me-2"
                                      onClick={() => {
                                        setLocationData(loc)
                                        toggleModal()
                                        setModalType("edit")
                                      }}
                                    >
                                      <FaPen size={14} />
                                    </Button>
                                  )}
                                  {checkAccess(5, 5) && (
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() =>
                                        handleDelete(loc.id, loc.name)
                                      }
                                    >
                                      <MdDelete size={14} />
                                    </Button>
                                  )}
                                </div>
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <Badge
                                    color={
                                      loc?.signature ? "success" : "danger"
                                    }
                                    pill
                                    className="me-2 flex-shrink-0"
                                    style={{ lineHeight: "1.4" }}
                                  >
                                    {loc?.signature ? "Signed" : "Not Signed"}
                                  </Badge>
                                  <Button
                                    color="primary"
                                    size="sm"
                                    className="flex-shrink-0"
                                    onClick={() => {
                                      setselectedLocation(loc),
                                        setContractModal(true)
                                    }}
                                  >
                                    <FaFileContract size={14} />
                                  </Button>
                                  {loc?.signature !== null && (
                                    <Button
                                      color="secondary"
                                      size="sm"
                                      className="ms-2 flex-shrink-0"
                                      onClick={() => {
                                        setselectedLocation(loc),
                                          setPDFModal(true)
                                      }}
                                    >
                                      <FaFilePdf size={14} />
                                    </Button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center text-muted">
                              No locations found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination */}
                  <div className="d-flex justify-content-between gap-2 flex-wrap">
                    <p className="mb-0">
                      Showing {paginatedLocation.length} out of{" "}
                      {locationList.length} Locations.
                    </p>
                    <div>
                      <Button
                        size="sm"
                        disabled={currentPage === 1}
                        className="fs-6"
                        onClick={() => setCurrentPage(prev => prev - 1)}
                      >
                        <FaChevronCircleLeft />
                      </Button>
                      {Array.from({ length: totalPages }, (_, i) => (
                        <Button
                          key={i}
                          size="sm"
                          className="mx-2 fs-6"
                          color={currentPage === i + 1 ? "primary" : "light"}
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </Button>
                      ))}
                      <Button
                        size="sm"
                        className="fs-6"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(prev => prev + 1)}
                      >
                        <FaChevronCircleRight />
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <LocationModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          locationData={locationData}
          onChange={handleChange}
          onSave={handleSave}
          type={modalType}
          services={services}
          employees={employees}
          setlocationData={setLocationData}
          sageOptions={sageOptions}
        />

        <LocationTimeModal
          isOpen={timeToggle}
          toggle={() => setTimeToggle(false)}
          selectedLocation={selectedLocation?.id}
          locationName={selectedLocation?.name}
          fetchLocations={fetchlocations}
          startDate={selectedLocation?.startDate}
          endDate={selectedLocation?.endDate}
          employmentType={selectedLocation?.employmentType}
        />

        <Modal
          isOpen={holidayModal}
          toggle={() => setHolidayModal(false)}
          centered
        >
          <ModalHeader toggle={() => setHolidayModal(false)}>
            Off Dates
          </ModalHeader>
          <ModalBody>
            <Table bordered responsive hover className="bg-light">
              <thead className="bg-blue text-white">
                <tr>
                  <th>Employee Name</th>
                  <th>From Date</th>
                  <th>To Date</th>
                </tr>
              </thead>
              <tbody>
                {selectedLocation?.holidays?.map((item, index) => (
                  <tr key={item?.id}>
                    <td>{item?.employee?.name}</td>
                    <td>
                      {moment(item?.fromDate, "YYYY-MM-DD").format(
                        "DD/MM/YYYY"
                      )}
                    </td>
                    <td>
                      {moment(item?.toDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={offmodal}
          toggle={() => setOffModal(false)}
          centered
          size="lg"
        >
          <ModalHeader toggle={() => setOffModal(false)}>
            Holiday Dates
          </ModalHeader>
          <ModalBody>
            <div
              className="d-flex gap-4 align-items-end pb-3 flex-wrap"
              style={{ borderBottom: "1px solid #333" }}
            >
              <div>
                <label>Holiday Date</label>
                <input
                  type="date"
                  className="form-control w-auto"
                  value={holiday?.date || ""}
                  onChange={e =>
                    setHoliday(prev => ({
                      ...prev,
                      date: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="flex-grow-1" style={{ minWidth: "200px" }}>
                <label>Holiday Reason</label>
                <input
                  className="form-control"
                  value={holiday?.reason}
                  onChange={e =>
                    setHoliday(prev => ({
                      ...prev,
                      reason: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <Button
                className="rounded-4 fw-bold"
                onClick={() => AddHoliday()}
              >
                <MdAdd /> Add Holiday
              </Button>
            </div>
            <div className="mt-4">
              <h6>Previous Holiday's</h6>
              <Table striped className="bg-white">
                <thead>
                  <tr>
                    <td>#</td>
                    <td>Date</td>
                    <td>Reason</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {selectedLocation?.publicHolidays?.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No Holiday's Added.
                      </td>
                    </tr>
                  )}
                  {selectedLocation?.publicHolidays?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{moment(item?.date)?.format("DD/MM/YYYY")}</td>
                      <td>{item?.reason}</td>
                      <td>
                        <Button
                          className="bg-danger "
                          onClick={() => DeleteHoliday(item?.id)}
                        >
                          <MdDelete />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </ModalBody>
        </Modal>

        <ContractModal
          isOpen={contractModal}
          toggle={() => setContractModal(false)}
          location={selectedLocation}
          fetchLocations={fetchlocations}
        />

        <ContractPDF
          isOpen={pdfModal}
          toggle={setPDFModal}
          location={selectedLocation}
        />
      </PermittedComponent>
    </div>
  )
}

export default LocationIndex
